import { memo } from 'react'

import { cardsItemMenu } from '@/modules/shared/constants/cards-item-menu'
import { useAuthStore } from '@/modules/shared/stores/auth.store'

import { CardItemMenu } from '../card-item'
import type { CardsItemMenuProps, ICardMenuProps } from '../interfaces'

const CardItemMenuMemo = memo(CardItemMenu)

export function CardMenu({ menuType }: ICardMenuProps) {
  const nivelAcesso = useAuthStore((state) => state.nivelAcesso ?? 1)

  const itemsMenu = cardsItemMenu[menuType].filter((item: CardsItemMenuProps) => {
    return item.niveisAcesso?.includes(nivelAcesso) ?? true
  })
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">

      {itemsMenu.map((item: CardsItemMenuProps) => {
        return (
          <div key={item.id}>
            <CardItemMenuMemo
              dataTest={item.dataTest}
              textCard={item.textCard}
              Icon={item.icon}
              route={item.route}
            />
          </div>
        )
      })}
    </div>
  )
}
